import { Component, Match, Show, Switch, createSignal, onMount } from 'solid-js'
import { adminStore, i18nStore, settingStore, userStore } from '../../store'
import Button from '/web/shared/Button'
import { useNavigate } from '@solidjs/router'
import { Pill, SolidCard } from '/web/shared/Card'

const PatreonOauth: Component = () => {
  const i18n = i18nStore((s) => s)
  const nav = useNavigate()

  const [state, setState] = createSignal<'success' | 'error' | undefined>()
  const [message, setMessage] = createSignal('')

  onMount(() => {
    const result = location.search
      .slice(1)
      .split('&')
      .reduce<any>(
        (prev, curr) => {
          const [key, value] = curr.split('=')
          return Object.assign(prev, { [key]: value })
        },
        { url: `${location.origin}/oauth/patreon` }
      )

    userStore.verifyPatreon(result, (error) => {
      if (error) {
        setMessage(error)
        setState('error')
        return
      }

      setState('success')

      userStore.getConfig()

      setTimeout(() => {
        nav('/settings')
      }, 2500)
    })
  })

  return (
    <SolidCard>
      <div class="flex flex-col items-center gap-2">
        <Switch>
          <Match when={!state()}>{i18n.t.patreon_oauth_verifying}</Match>

          <Match when={state() === 'error'}>
            <div class="text-red-500">{i18n.t.patreon_oauth_error}</div>
            <div>{message()}</div>
            <div>
              <Button onClick={() => nav('/settings')}>{i18n.t.patreon_oauth_return_to_settings}</Button>
            </div>
          </Match>

          <Match when={state() === 'success'}>
            <div class="text-green-500">{i18n.t.patreon_oauth_success}</div>
            <div>{i18n.t.patreon_oauth_redirecting}</div>
          </Match>
        </Switch>
      </div>
    </SolidCard>
  )
}

export const PatreonControls: Component = () => {
  const i18n = i18nStore((s) => s)
  const config = settingStore((s) => ({ config: s.config }))
  const state = userStore((s) => ({ user: s.user }))
  const admin = adminStore((s) => ({ impersonating: s.impersonating }))

  return (
    <Show when={config.config.patreonAuth}>
      <div class="flex w-full justify-center">
        <Show when={!state.user?.patreon}>
          <div class="flex flex-col items-center gap-1">
            <Pill type="green">{i18n.t.patreon_oauth_link_benefit}</Pill>
            <Button class="w-fit" onClick={authorizePatreon}>
              {i18n.t.patreon_oauth_link}
            </Button>
          </div>
        </Show>
        <Show when={state.user?.patreon}>
          <div class="flex gap-2">
            <Button class="w-fit" onClick={userStore.unverifyPatreon}>
              {i18n.t.patreon_oauth_unlink}
            </Button>
          </div>
        </Show>
        <Show when={state.user?.admin || admin.impersonating}>
          <Button class="ml-2" onClick={() => userStore.validateSubscription()}>
            {i18n.t.patreon_oauth_revalidate}
          </Button>
        </Show>
      </div>
    </Show>
  )
}

export default PatreonOauth

function authorizePatreon() {
  const { config } = settingStore.getState()
  const scopes = ['identity', 'identity.memberships', 'identity[email]']
  const redir = `${location.origin}/oauth/patreon`
  const params = [
    `response_type=code`,
    `client_id=${config.patreonAuth?.clientId}`,
    `scope=${scopes.join(' ')}`,
    `redirect_uri=${redir}`,
  ]
  const url = `https://www.patreon.com/oauth2/authorize?${encodeURI(params.join('&'))}`
  window.open(url, '_self')
}
